// Reactive, app-wide softphone state — owned/written by GlobalSoftphone,
// read by any page (e.g. the confirmation page Call button) so it knows
// whether this agent has a WebRTC line, is registered, and is on a call.
import Vue from "vue";

export default Vue.observable({
  useWebrtc: false, // this agent has a desktop WebRTC extension
  registered: false, // the softphone is registered to FreePBX
  // The signaling socket (WSS to the PBX on :8089) could NOT be reached, or
  // registration kept failing. Distinguishes a genuine "can't connect" (agent
  // off the office LAN / VPN, PBX down, cert/port blocked) from the brief,
  // normal "connecting…" window right after load. When true the UI shows a
  // clear offline message and DISABLES the Call button (a click-to-call can't
  // work without a registered line). Set after repeated failures, cleared on
  // the next successful register.
  connFailed: false,
  inCall: false, // a call (in/out) is currently active
  // The confirmation page is currently mounted and will render the incoming-call
  // screen-pop ITSELF (in-page), so the app-wide GlobalSoftphone must NOT also
  // show its floating inbound popup — otherwise the agent sees it twice. When
  // false (agent is on any other page), the GlobalSoftphone shows the floating
  // popup so a customer callback is never missed. confirmation.vue sets this
  // true on mount, false on destroy.
  inboundPageActive: false,
  // Auto-dialer waitForClientAnswer mode: the agent leg auto-answers immediately
  // (Asterisk needs it to Dial the customer), but the customer is still ringing /
  // being AMD-analyzed. During that window we must NOT show the in-call widget or
  // pop the order — the agent should see only the auto-dialer "ringing" overlay.
  // The confirmation page sets this true while polling for the REAL client answer,
  // and clears it once the customer really answers (or the call ends). While true,
  // GlobalSoftphone hides its floating in-call widget.
  suppressWidget: false,
  // Last softphone error surfaced to the UI (e.g. the mic failing to open, which
  // is the usual reason a click-to-call rings but never connects). Shape:
  // { kind: "mic-blocked"|"mic-busy"|"mic-missing"|"generic", at: <ts> }.
  lastError: null,
});
